import styled, { css } from 'styled-components';

import { Button, StatusInfoModal, mediaQuery } from '@catalyze/ui';
import { cardContainerStyle } from 'features/SignUp/components/CardContainer';

export const StyledButton = styled(Button)`
    width: 100%;
`;

interface IStatusInfoModalProps {
    bigPadding?: boolean;
}

export const StyledStatusInfoModal = styled(
    StatusInfoModal
)<IStatusInfoModalProps>`
    ${cardContainerStyle}
    align-items: center;
    ${({ bigPadding }) =>
        bigPadding &&
        mediaQuery(
            2,
            css`
                padding: 4rem;
            `
        )}
`;
